import { FC } from 'react';
import { Avatar } from '@chakra-ui/react';
import RentennialsNextImage from '@components/images/RentennialsNextImage';

interface ReviewCardProps {
  name: string;
  avatarImage?: string;
  review: string;
  avatarContainerClasses?: string;
}

const ReviewCard: FC<ReviewCardProps> = ({ name, avatarImage, review, avatarContainerClasses }) => {
  return (
    <div className="relative mx-2 flex items-center justify-center py-8">
      <div className="h-[280px] rounded-[40px] bg-white px-5 max-[1021px]:w-[450px] max-[1020px]:w-full lg:w-[340px]">
        <div
          className={`absolute top-0  ${avatarContainerClasses}`}
          style={{
            left: 'calc(50% - 40px)'
          }}
        >
          <Avatar src={avatarImage} size="lg" name={name} />
        </div>
        <div className="flex h-full flex-col items-center justify-between py-10 pt-5">
          <div className="flex w-full justify-end">
            <RentennialsNextImage
              alt="Google Logo"
              src="/images/Google_Iso.svg"
              width="24"
              height="24"
              className=""
              loading="lazy"
            />
          </div>
          <div className="flex flex-1 flex-col items-center justify-center gap-y-4 px-2 tablet:px-5">
            <p className="font-bree-serif text-[16px] font-normal text-rentennials-primary tablet:text-[18px]">
              {name}
            </p>
            <p className="text-center font-roboto text-[12px] text-rentennials-text lg:h-[90px]">{review}</p>
          </div>
          <div className="pt-4">
            <RentennialsNextImage
              alt="5 star review"
              src="/images/Reviews_Stars.svg"
              width={0}
              height={0}
              className="h-[40px] w-[150px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
